




































import Vue, { PropType } from "vue";
import { BIcon, BIconArrowClockwise } from "bootstrap-vue";

import { QueryState } from "../api";
import BookListItem from "./BookListItem.vue";
import { Book, Library } from "../types/bibliocommons";

export default Vue.extend({
  components: {
    BIcon,
    // eslint-disable-next-line vue/no-unused-components
    BIconArrowClockwise,
    BookListItem
  },
  props: {
    library: {
      type: Object as () => Library,
      required: false
    },
    state: {
      type: Number as () => QueryState,
      required: true
    },
    books: {
      type: Array as PropType<Array<Book>>,
      required: true
    }
  },
  computed: {
    howToCheckoutUrl: function(): string | null {
      if (!this.library) {
        return null;
      }
      const urlBySubdomain: Record<string, string> = {
        seattle:
          "https://www.spl.org/hours-and-locations/road-to-reopening/curbside-service",
        sfpl: "https://sfpl.org/sfpl-to-go",
        aclibrary: "https://guides.aclibrary.org/NoContactPickup"
      };
      return urlBySubdomain[this.library.subdomain] || null;
    },
    noResultsFound(): boolean {
      return this.state === QueryState.COMPLETED && !this.books.length;
    },
    fewResultsFound(): boolean {
      return this.state === QueryState.COMPLETED && this.books.length < 5;
    }
  },
  data() {
    return { QueryState };
  }
});
